<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background Overlay -->
    <div class="fixed inset-0 bg-[#D4D7DE] dark:bg-[#3333331f] bg-opacity-75 transition-opacity backdrop-blur-sm"></div>
    <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class="fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <div class="w-screen max-w-md px-2 py-2 bg-white dark:bg-zinc-950 h-screen overflow-scroll">
                    <!-- Modal Content -->
                    <form class="mt-4 px-4" [formGroup]="manualPaymentForm">
                        <div class="flex justify-between">
                            <div>
                                <h2 class="heading">
                                    Pay
                                </h2>
                                <p class="text-sm-light">
                                    {{ billingIds.length ? billingIds.length + ' selected billings' : (trip?.reference || '') + (trip?.suffix ? '-' + trip.suffix : '') }}
                                </p>
                            </div>
                            <div>
                                <button type="button" (click)="onCloseModal()"
                                    class="rounded-lg p-1 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
                                    <span class="sr-only">Close panel</span>
                                    <!-- Heroicon name: outline/x-mark -->
                                    <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none"
                                        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                        aria-hidden="true">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>

                        <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />

                        <section class="flex-1 flex flex-col overflow-y-auto space-y-6">
                            <div>
                                <label for="transaction_no" class="block text-sm font-medium text-main-secondary">
                                    Transaction No <span class="text-red-600">*</span>
                                </label>
                                <div class="mt-1">
                                    <input formControlName="transaction_no" type="text" name="transaction_no"
                                        id="transaction_no" />
                                </div>
                                <div *ngIf="form.transaction_no.errors && submitted">
                                    <div *ngIf="form.transaction_no.errors.required" class="error">
                                        <p class="mt-2 text-red-600 text-xs">
                                            Transaction No is required
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label for="paymentType" class="block text-sm font-medium text-main-secondary">
                                    Payment Type <span class="text-red-600">*</span>
                                </label>
                                <div class="mt-1">
                                    <select id="paymentType" formControlName="paymentType" class="w-full">
                                        <option value="">Select Payment Type</option>
                                        <option value="check">Check</option>
                                        <option value="cash">Cash</option>
                                    </select>
                                </div>
                                <div *ngIf="form.paymentType.errors && submitted">
                                    <div *ngIf="form.paymentType.errors.required" class="error">
                                        <p class="mt-2 text-red-600 text-xs">
                                            Payment Type is required
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="!billingIds.length">
                                <label for="notes" class="block text-sm font-medium text-main-secondary">
                                    Notes
                                </label>
                                <div class="mt-1">
                                    <textarea rows="4" formControlName="notes" name="notes" id="notes"
                                        class="resize-none form-control"></textarea>
                                </div>
                            </div>

                            <div class="flex justify-end gap-2">
                                <button type="button" class="btn btn-secondary" (click)="onCloseModal()">
                                    Cancel
                                </button>
                                <button type="button" class="btn btn-primary" (click)="onSave()">
                                    Save
                                </button>
                            </div>
                        </section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
